import React, { useState, useEffect } from "react";
import "./AddVehicle.css";
import Swal from "sweetalert2";

import Select from "react-select";
import axios from "axios";
import WOW from "wow.js";
import "animate.css";
import { Helmet } from "react-helmet";

export default function AddVehicle() {
  useEffect(() => {
    new WOW().init();
  }, []);
  const headers = {
    token: localStorage.getItem("userToken"),
  };

  const [Cars, setCars] = useState([]);
  // const [selectedMethod, setSelectedMethod] = useState(null);
  const [selectedCar, setSelectedCar] = useState(null);
  const [vin, setVin] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  let [mileage, setmileage] = useState("");

  const validateVIN = (vin) => {
    const vinRegex = /^[A-HJ-NPR-Z0-9]*$/i;
    if (!vinRegex.test(vin)) {
      setErrorMessage(
        "VIN must contain only 17 letters and numbers, excluding I, O, and Q."
      );
    } else if (vin.length === 17) {
      setErrorMessage("");
    } else {
      setErrorMessage(
        "VIN must contain only 17 letters and numbers, excluding I, O, and Q."
      );
    }
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    setVin(inputValue);
    validateVIN(inputValue);
  };
  let [carbrand, setcarbrand] = useState([]);

  async function getcarBrand() {
    let response = await axios.get(
      `https://vehex-production.up.railway.app/car/getAllcarBrands`
    );
    if (response.data.message === "Car Brands retrieved successfully.") {
      setcarbrand(response.data.cars);
    }
    console.log(response.data);
  }
  useEffect(() => {
    getcarBrand();
  }, []);

  const options = carbrand?.map((brand) => ({
    value: brand.carBrandLogo.url,
    label: brand.carBrand,
  }));

  async function addDataVehicle() {
    const logoUrl = selectedCar ? selectedCar.value : "";
    const logoFile = await fetch(logoUrl).then((response) => response.blob());

    const mileage = document.getElementById("mileagee")?.value;
    const model = document.getElementById("modell")?.value;
    const year = document.getElementById("yearr")?.value;
    const agency = document.getElementById("agencyy")?.value;
    const warranty =
      document.querySelector('.dataa input[name="warrantyStatus"]:checked')
        ?.id === "warranty"
        ? true
        : false;
    console.log(mileage);
    console.log(model);
    console.log(year);
    console.log(warranty);
    if (!logoFile || !mileage || !model || !year || !agency || !warranty) {
      Swal.fire({
        icon: "error",
        title: "Incomplete Data",
        text: "Please fill in all fields before add vehicle!",
        confirmButtonText: "OK",
      });
    }

    const formData = new FormData();
    formData.append("logo", logoFile, "logo.png");
    formData.append("mileage", mileage);
    formData.append("model", model);
    formData.append("year", year);
    formData.append("agency", agency);
    formData.append("warranty", warranty);

    try {
      const response = await axios.post(
        "https://vehex-production.up.railway.app/car/registerUserCar",
        formData,
        { headers }
      );
      console.log(response.data);
      console.log(logoFile);
      if (
        response.data.message ===
        "Car registered successfully with car details."
      ) {
        Swal.fire({
          icon: "success",
          text: "Car registered successfully with car details",
          confirmButtonText: "OK",
        });
        getUserCarBydata();
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: "Error adding vehicle",
        confirmButtonText: "OK",
      });
    }
  }

  async function addVinVehicle() {
    const logoUrlVIN = selectedCar ? selectedCar.value : "";
    const logoFile = await fetch(logoUrlVIN).then((response) =>
      response.blob()
    );
    const mileage = document.getElementById("mileageVinn").value;
    const engineNumber = document.getElementById("engineNumberr").value;
    console.log(mileage);
    console.log(logoFile);
    console.log(engineNumber);
    if (!logoFile || !mileage || !engineNumber) {
      Swal.fire({
        icon: "error",
        title: "Incomplete Data",
        text: "Please fill in all fields before add vehicle!",
        confirmButtonText: "OK",
      });
    }

    const formData = new FormData();
    formData.append("logo", logoFile, "logo.png");
    formData.append("mileage", mileage);
    formData.append("engineNumber", engineNumber);

    try {
      const response = await axios.post(
        "https://vehex-production.up.railway.app/car/registerUserCar",
        formData,
        { headers }
      );
      console.log(response.data);
      console.log(logoFile.type);
      if (
        response.data.message ===
        "Car registered successfully with engine number."
      ) {
        Swal.fire({
          icon: "success",
          text: "Car registered successfully with Vehicle Number",
          confirmButtonText: "OK",
        });
        getUserCarBydata();
      } else if (
        response.data.err ===
        "You already have a car registered with this Vehicle Number."
      ) {
        Swal.fire({
          icon: "warning",
          text: "You already have a car registered with this Vehicle Number",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: "Error adding vehicle",
        confirmButtonText: "OK",
      });
    }
  }

  const handleVINFormSubmit = (e) => {
    e.preventDefault();
  };

  async function getUserCarBydata() {
    let response = await axios.get(
      "https://vehex-production.up.railway.app/car/userCars",
      {
        headers,
      }
    );
    console.log(response);
    setCars(response?.data.cars);
  }
  useEffect(() => {
    getUserCarBydata();
  }, []);

  async function deleteCar(carIdd) {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          let response = await axios.delete(
            `https://vehex-production.up.railway.app/car/deleteUserCarForUser/${carIdd}`,
            {
              headers,
            }
          );

          if (response.data.message === "Car deleted successfully.") {
            Swal.fire({
              title: "Deleted!",
              text: "The car has been deleted.",
              icon: "success",
              confirmButtonColor: "#3085d6",
            });
            setCars((prevCars) => prevCars.filter((car) => car._id !== carId));
            getUserCarBydata();
          }
        } catch (error) {
          console.error("Error deleting car:", error);
          Swal.fire({
            title: "Error!",
            text: "There was an issue deleting the car.",
            icon: "error",
            confirmButtonColor: "#d33",
          });
        }
      }
    });
  }

  const [carId, setCarId] = useState(null);

  function setFormForUpdate(carId) {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    setCarId(carId);
    const selectedCar = Cars.find((car) => car._id === carId);
    if (!selectedCar) return;
    if (selectedCar.engineNumber) {
      document.getElementById("carVin").classList.replace("d-none", "d-block");
      document.getElementById("carData").classList.replace("d-block", "d-none");
      document.getElementById("mileageVin").value = selectedCar.mileage || "";

      setmileage(selectedCar.mileage || "");
      console.log(mileage);
      setVin(selectedCar.engineNumber || "");
    } else if (selectedCar.carDetails) {
      document.getElementById("carData").classList.replace("d-none", "d-block");
      document.getElementById("carVin").classList.replace("d-block", "d-none");
      document.getElementById("mileageData").value = selectedCar.mileage || "";
      document.getElementById("modelData").value =
        selectedCar.carDetails.model || "";
      document.getElementById("yearData").value =
        selectedCar.carDetails.year || "";
      document.getElementById("agencyData").value =
        selectedCar.carDetails.agency || "";
      const warrantyStatus = selectedCar.carDetails.warranty
        ? "warrantyy"
        : "outOfWarrantyy";
      document.getElementById(warrantyStatus).checked = true;
    }
  }
  async function UpdateCarData(carId) {
    console.log(carId);
    const mileage = document.getElementById("mileageData")?.value;
    const model = document.getElementById("modelData")?.value;
    const year = document.getElementById("yearData")?.value;
    const agency = document.getElementById("agencyData")?.value;
    const warranty =
      document.querySelector('.CarData input[name="warrantyStatus"]:checked')
        ?.id === "warranty"
        ? true
        : false;
    console.log(mileage);
    console.log(model);
    console.log(year);
    console.log(warranty);
    console.log(agency);
    const formData = new FormData();
    formData.append("carDetails[model]", model);
    formData.append("carDetails[year]", year);
    formData.append("carDetails[agency]", agency);
    formData.append("carDetails[warranty]", warranty);
    formData.append("mileage", mileage);

    try {
      const response = await axios.put(
        `https://vehex-production.up.railway.app/car/updateUserCar/${carId}`,
        formData,
        { headers }
      );
      console.log(response.data);

      if (response.data.message === "Car updated successfully.") {
        Swal.fire({
          icon: "success",
          text: "Car updated successfully.",
          confirmButtonText: "OK",
        });
        document
          .getElementById("carData")
          .classList.replace("d-block", "d-none");
        getUserCarBydata();
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: "Error updating vehicle",
        confirmButtonText: "OK",
      });
    }
  }
  async function UpdateCarVin(carId) {
    console.log(carId);
    const engineNumber = document.getElementById("engineNumberVin")?.value;
    const mileageVin = document.getElementById("mileageVin")?.value;
    console.log(engineNumber);
    console.log(mileageVin);

    const formData = new FormData();
    formData.append("engineNumber", engineNumber);
    formData.append("mileage", mileageVin);

    try {
      const response = await axios.put(
        `https://vehex-production.up.railway.app/car/updateUserCar/${carId}`,
        formData,
        { headers }
      );
      console.log(response.data);

      if (response.data.message === "Car updated successfully.") {
        Swal.fire({
          icon: "success",
          text: "Car updated successfully.",
          confirmButtonText: "OK",
        });
        document
          .getElementById("carVin")
          .classList.replace("d-block", "d-none");
        getUserCarBydata();
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: "Error updating vehicle",
        confirmButtonText: "OK",
      });
    }
  }

  const [toggleStatecar, settoggleStateCar] = useState(1);

  const toggleTapCar = (index) => {
    settoggleStateCar(index);
  };

  return (
    <>
      <Helmet>
        <title>Add Vehicle</title>
      </Helmet>
      <div className="caruser ">
        <div className="container w-75">
          <form id="carData" className="d-none pt-5">
            <div className="big d-flex flex-column">
              <label
                htmlFor="mileageData"
                className="main-color fw-500 fs-5 mb-2"
              >
                KM
              </label>
              <input
                type="number"
                id="mileageData"
                name="mileage"
                className="form-control mb-2 "
              />

              <label
                htmlFor="modelData"
                className="main-color fw-500 fs-5 mb-2"
              >
                Model
              </label>
              <input
                type="text"
                id="modelData"
                name="model"
                className="form-control mb-2"
              />

              <label htmlFor="yearData" className="main-color fw-500 fs-5 mb-2">
                Year
              </label>
              <input
                type="number"
                id="yearData"
                name="year"
                className="form-control mb-2"
              />

              <label
                htmlFor="agencyData"
                className="main-color fw-500 fs-5 mb-2"
              >
                Agency
              </label>
              <input
                type="text"
                id="agencyData"
                name="agency"
                className="form-control mb-2"
              />

              <div className="dataa d-flex align-items-center justify-content-start gap-3">
                <label htmlFor="warranty" className="main-color fs-5 fw-500">
                  Warranty:
                </label>

                <div className="d-flex align-items-center gap-3 CarData">
                  <div className="one">
                    <label
                      htmlFor="warrantyy"
                      className="main-color fw-500 fs-5"
                    >
                      True
                    </label>
                    <input
                      type="radio"
                      className="ms-2"
                      id="warrantyy"
                      name="warrantyStatus"
                    />
                  </div>
                  <div className="two d-flex align-items-center">
                    <label
                      htmlFor="outOfWarrantyy"
                      className="main-color fw-500 fs-5"
                    >
                      False
                    </label>
                    <input
                      type="radio"
                      className="ms-2"
                      id="outOfWarrantyy"
                      name="warrantyStatus"
                    />
                  </div>
                </div>
              </div>
            </div>

            <button
              className="btn btn-danger my-3 m-auto d-block"
              onClick={(e) => {
                e.preventDefault();
                UpdateCarData(carId);
              }}
            >
              Update Vehicle
            </button>
          </form>
          <form id="carVin" className="d-none pt-5 ">
            <div className="big d-flex flex-column">
              <label
                htmlFor="engineNumberVin"
                className="main-color fw-500 fs-5 mb-2"
              >
                Vehicle Number (VIN)
              </label>
              <input
                type="text"
                placeholder="for Example: 1HGBH41JXMN109186"
                id="engineNumberVin"
                name="engineNumber"
                className="form-control mb-2"
                value={vin}
                onChange={handleInputChange}
              />
              {/* عرض الرسالة في حالة وجود خطأ */}
              {errorMessage && (
                <p className="bg-danger fs-6 text-white py-2 px-1 rounded">
                  {errorMessage}
                </p>
              )}

              <label
                htmlFor="mileageVin"
                className="main-color fw-500 fs-5 mb-2"
              >
                KM
              </label>
              <input
                type="number"
                id="mileageVin"
                name="mileage"
                className="form-control mb-2"
              />
            </div>

            <button
              className="btn btn-danger my-3 m-auto d-block"
              onClick={(e) => {
                e.preventDefault();
                UpdateCarVin(carId);
              }}
            >
              Update Vehicle
            </button>
          </form>
        </div>
        <div className="dataForm py-5 container w-75 m-auto ">
          <h1 className=" fs-3 main-color heading">
            Please choose the appropriate method for you to add a Vehicle:
          </h1>
          <div className="choiceMethod bg-second-color d-flex justify-content-start align-items-center ">
            <div
              className={
                toggleStatecar === 1
                  ? "one activeToggleCar  w-50 "
                  : "one  w-50  "
              }
              onClick={() => toggleTapCar(1)}
            >
              {/* <input
                type="radio"
                id="data"
                name="datachoice"
                // onChange={() => setSelectedMethod("data")}
              /> */}
              <label htmlFor="data" className=" fw-500 fs-4 mx-2">
                Add Vehicle By Data
              </label>
            </div>
            <div
              onClick={() => toggleTapCar(2)}
              className={
                toggleStatecar === 2 ? "two activeToggleCar w-50 " : "two w-50"
              }
            >
              {/* <input
                type="radio"
                id="vin"
                name="datachoice"
                onChange={() => setSelectedMethod("vin")}
              /> */}
              <label htmlFor="vin" className=" fw-500 fs-4 mx-2">
                Add Vehicle By VIN
              </label>
            </div>
          </div>

          <div className="pt-3 addvehicle px-3">
            {/* Form 1: Add Vehicle By Data */}
            {/* {selectedMethod === "data" && ( */}
            <form
              className={toggleStatecar === 1 ? " activationContent" : "d-none"}
            >
              <div className="big d-flex flex-column">
                <label
                  htmlFor="carBrand"
                  className="main-color fw-500 fs-5 mb-2"
                >
                  Car Brand
                </label>
                <Select
                  options={options}
                  className="mb-2"
                  id="carBrand"
                  onChange={(selectedOption) => setSelectedCar(selectedOption)}
                />

                <label
                  htmlFor="mileagee"
                  className="main-color fw-500 fs-5 mb-2"
                >
                  KM
                </label>
                <input
                  type="number"
                  id="mileagee"
                  name="mileage"
                  className="form-control mb-2 "
                />

                <label htmlFor="modell" className="main-color fw-500 fs-5 mb-2">
                  Model
                </label>
                <input
                  type="text"
                  id="modell"
                  name="model"
                  className="form-control mb-2"
                />

                <label htmlFor="yearr" className="main-color fw-500 fs-5 mb-2">
                  Year
                </label>
                <input
                  type="number"
                  id="yearr"
                  name="year"
                  className="form-control mb-2"
                />

                <label
                  htmlFor="agencyy"
                  className="main-color fw-500 fs-5 mb-2"
                >
                  Agency
                </label>
                <input
                  type="text"
                  id="agencyy"
                  name="agency"
                  className="form-control mb-2"
                />

                <div className="dataa d-flex align-items-center justify-content-start gap-3">
                  <label htmlFor="warranty" className="main-color fs-5 fw-500">
                    Warranty:
                  </label>

                  <div className="d-flex align-items-center gap-3">
                    <div className="one">
                      <label
                        htmlFor="warranty"
                        className="main-color fw-500 fs-5"
                      >
                        True
                      </label>
                      <input
                        type="radio"
                        className="ms-2"
                        id="warranty"
                        name="warrantyStatus"
                      />
                    </div>
                    <div className="two d-flex align-items-center">
                      <label
                        htmlFor="outOfWarranty"
                        className="main-color fw-500 fs-5"
                      >
                        False
                      </label>
                      <input
                        type="radio"
                        className="ms-2"
                        id="outOfWarranty"
                        name="warrantyStatus"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <button
                className="btn btn-danger my-3  m-auto d-block"
                onClick={(e) => {
                  e.preventDefault();
                  addDataVehicle();
                }}
              >
                Add Vehicle
              </button>
            </form>
            {/* )} */}

            {/* Form 2: Add Vehicle By VIN */}
            {/* {selectedMethod === "vin" && ( */}
            <form
              className={toggleStatecar === 2 ? " activationContent" : "d-none"}
              onSubmit={handleVINFormSubmit}
            >
              <div className="big d-flex flex-column">
                <label
                  htmlFor="carBrand"
                  className="main-color fw-500 fs-5 mb-2"
                >
                  Car Brand
                </label>
                <Select
                  options={options}
                  className="mb-2"
                  id="carBrand"
                  onChange={(selectedOption) => setSelectedCar(selectedOption)}
                />
                <label
                  htmlFor="engineNumberr"
                  className="main-color fw-500 fs-5 mb-2"
                >
                  Vehicle Number (VIN)
                </label>
                <input
                  type="text"
                  placeholder="for Example: 1HGBH41JXMN109186"
                  id="engineNumberr"
                  name="engineNumber"
                  className="form-control mb-2"
                  value={vin}
                  onChange={handleInputChange}
                />
                {/* عرض الرسالة في حالة وجود خطأ */}
                {errorMessage && (
                  <p className="bg-danger fs-6 text-white py-2 px-1 rounded">
                    {errorMessage}
                  </p>
                )}

                <label
                  htmlFor="mileageVinn"
                  className="main-color fw-500 fs-5 mb-2"
                >
                  KM
                </label>
                <input
                  type="number"
                  id="mileageVinn"
                  name="mileage"
                  className="form-control mb-2"
                />
              </div>

              <button
                className="btn btn-danger my-3 m-auto d-block"
                onClick={(e) => {
                  e.preventDefault();
                  addVinVehicle();
                }}
              >
                Add Vehicle
              </button>
            </form>
            {/* )} */}
          </div>
        </div>
      </div>

      <div className="userCarData">
        <div className="container cardd my-5 w-75 m-auto">
          {Cars?.length > 0
            ? Cars.map((car, index) => (
                <div
                  className="container box d-flex justify-content-between align-items-start"
                  key={car._id}
                  style={{
                    padding: "20px",
                  }}
                >
                  {car.engineNumber ? (
                    <>
                      <div className="imgCar w-25 me-3">
                        <img
                          src={car.logo.url}
                          alt="Car Logo"
                          className="w-75 mb-3"

                        />
                      </div>
                      <div className="dataControl d-flex justify-content-between flex-fill gap-5">
                        <div>
                          <p className="fw-bold text-black fs-5 m-0">
                            Vehicle Number:{" "}
                            <span className="main-color fw-400">
                              {car.engineNumber}
                            </span>
                          </p>
                          <p className="fw-bold fs-5 text-black m-0">
                            KM:{" "}
                            <span className="main-color fw-400">
                              {car.mileage || "___"} Km
                            </span>
                          </p>
                        </div>
                        <div className="d-flex flex-column">
                          <button
                            className="btn btn-primary mb-3"
                            onClick={() => setFormForUpdate(car._id)}
                          >
                            Update
                          </button>
                          <button
                            className="btn btn-danger"
                            onClick={() => deleteCar(car._id)}
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    </>
                  ) : car.carDetails ? (
                    <>
                      <div className="imgCar w-25 me-3">
                        <img
                          src={car.logo.url}
                          alt="Car Logo"
                          className="w-75 mb-3"
                        />
                      </div>
                      <div className="dataControl d-flex justify-content-between flex-fill gap-5">
                        <div className="flex-fill">
                          <p className="fw-bold text-black fs-5 m-0">
                            Agency:{" "}
                            <span className="main-color fw-400">
                              {car.carDetails.agency || "___"}
                            </span>
                          </p>
                          <p className="fw-bold text-black fs-5 m-0">
                            Model:{" "}
                            <span className="main-color fw-400">
                              {car.carDetails.model || "___"}
                            </span>
                          </p>
                          <p className="fw-bold text-black fs-5 m-0">
                            Year:{" "}
                            <span className="main-color fw-400">
                              {car.carDetails.year || "___"}
                            </span>
                          </p>
                          <p className="fw-bold text-black fs-5 m-0">
                            KM:{" "}
                            <span className="main-color fw-400">
                              {car.mileage || "___"} Km
                            </span>
                          </p>
                          <p className="fw-bold text-black fs-5 m-0">
                            Warranty:{" "}
                            <span className="main-color fw-400">
                              {car.carDetails.warranty !== undefined
                                ? car.carDetails.warranty
                                  ? "Yes"
                                  : "No"
                                : "___"}
                            </span>
                          </p>
                        </div>

                        <div className="d-flex flex-column">
                          <button
                            className="btn btn-primary mb-3"
                            onClick={() => setFormForUpdate(car._id)}
                          >
                            Update
                          </button>
                          <button
                            className="btn btn-danger"
                            onClick={() => deleteCar(car._id)}
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              ))
            : ""}
        </div>
      </div>
    </>
  );
}
